/**
 * Resolves the DOM node MUI overlays should portal into for a React island.
 * Prefer the in-tree portal host; fall back to the island mount element.
 * @param {Element | null | undefined} islandRootElement
 * @returns {HTMLElement | undefined}
 */
export function resolveIslandPortalContainer(islandRootElement) {
	if (!(islandRootElement instanceof HTMLElement)) {
		return undefined;
	}

	return islandRootElement;
}
